import { useState } from 'react';

/**
 * Hook personalizzato per gestire lo stato di un accordion
 * @param initialOpen - Stato iniziale dell'accordion (default: true)
 * @returns Oggetto con stato e funzioni per gestire l'accordion
 */
export const useAccordion = (initialOpen: boolean = true) => {
  const [isOpen, setIsOpen] = useState<boolean>(initialOpen);

  /**
   * Alterna lo stato aperto/chiuso dell'accordion
   */
  const toggle = () => {
    setIsOpen(prev => !prev);
  };

  /**
   * Imposta esplicitamente lo stato dell'accordion
   * @param open - Nuovo stato dell'accordion
   */
  const setOpen = (open: boolean) => {
    setIsOpen(open);
  };

  return {
    isOpen,
    toggle,
    setOpen
  };
};

export default useAccordion;